<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Contrato de Comisión Mercantil.</li>
      </template>
      <template slot="title">
        Contrato de Comisión Mercantil Inversionista.
      </template>
      <template slot="body">
        <InvestorMerchantContract />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import GenericPage from "./new-portal-views/GenericPage.vue";
import InvestorMerchantContract from "@components/contracts/InvestorMerchantContract";

export default {
  name: "InvestorMerchantContractPage",
  components: {
    InvestorMerchantContract,
    GenericPage
  }
}
</script>

<style scoped>

</style>